import React, { useState, useEffect, useContext } from 'react';
import './createNewArray.css';
import SliderComponent from '../../components/analysis/SliderComponent';
import AppContext from '../../AppContext';

const CreateNewArray = ({ joke, onSaveNewArray, onCancelRecording }) => {
  const [newArray, setNewArray] = useState([]);
  const [numOfTaglines, setNumOfTaglines] = useState(0);
  const [selectedOption, setSelectedOption] = useState('punchline');
  const { isRecording, setIsRecording } = useContext(AppContext);
  const [isSliderStopped, setIsSliderStopped] = useState(false);

  useEffect(() => {
    if (joke?.taglines) {
      const count = joke.taglines.length;
      setNumOfTaglines(count);
      setSelectedOption(count > 0 ? 'all' : 'punchline');
    }
  }, [joke]); 

  const handleSaveButton = () => {
    // Check if there's at least one number greater than zero
    const hasPositiveNumber = newArray.some(value => value > 0);
  
    if (!hasPositiveNumber) {
      alert("Audience responses must contain at least 1 number aobve zero.");
      return;
    }
  
    // Trim trailing zeros from the array
    const trimmedArray = [...newArray];
    while (trimmedArray.length > 0 && trimmedArray[trimmedArray.length - 1] === 0) {
      trimmedArray.pop();
    }
  
    // Call save only if the trimmed array contains positive numbers
    onSaveNewArray(trimmedArray, selectedOption);
    setIsRecording(false); // Stop recording after save
  };
  
  

  const handleCancelButton = () => {
    if (newArray.length > 0 && !window.confirm("You have unsaved data. Are you sure you want to cancel and lose your changes?")) {
      return;
    }
    onCancelRecording();
    setIsRecording(false); // Stop recording after cancel
  };

  const handleSliderStop = (updatedArray) => {
    setNewArray(updatedArray); // Set the newArray when the slider stops
    setIsSliderStopped(true); // Enable the save button after the slider stops
  };


  const getSelectedJokeText = () => {
    if (selectedOption === 'all') return 'Full Joke';
    if (selectedOption === 'punchline') return joke?.punchline?.text || 'No punchline available';
  
    const taglineIndex = parseInt(selectedOption.split('-')[1], 10) - 1;
    return joke?.taglines?.[taglineIndex]?.punchline?.text || `No tagline ${taglineIndex + 1} available`;
  };
  

  return (
    <div className="create-new-array-main-div">
      <p><b>Recording Audience Response for: </b><em>{getSelectedJokeText()}</em></p>

      <div className="option-buttons">
        {numOfTaglines > 0 && (
          <button
            className={selectedOption === 'all' ? 'selected' : ''}
            onClick={() => setSelectedOption('all')}
          >
            All
          </button>
        )}

        <button
          className={selectedOption === 'punchline' ? 'selected' : ''}
          onClick={() => setSelectedOption('punchline')}
        >
          Punchline
        </button> 

        {numOfTaglines > 0 &&
          Array.from({ length: numOfTaglines }).map((_, index) => (
            <button
              key={index}
              className={selectedOption === `tagline-${index + 1}` ? 'selected' : ''}
              onClick={() => setSelectedOption(`tagline-${index + 1}`)}
            >
              Tag {index + 1}
            </button>
          ))
        } 
      </div>

      
        <SliderComponent onStop={handleSliderStop} /> {/* Pass handleSliderStop */}
      

      <div className="btn-container">
        {
          <button 
          className="save-btn" 
          onClick={handleSaveButton} 
          disabled={!isSliderStopped || isRecording} // Disable when recording or slider hasn't stopped
        >
          Save
        </button>
        
        
        }
        <button className="cancel-btn" onClick={handleCancelButton} disabled={isRecording}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default CreateNewArray;
